import { createTheme } from '@mui/material/styles';

const sssSanjeevaniTheme = createTheme({
  palette: {
    primary: {
      main: '#0288d1', // Deep green from headers and logos
      light: '#4fa1e2',
      dark: '#0d4013',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#d32f2f', // Accent red (used in some highlights/icons)
      light: '#ef5350',
      dark: '#b71c1c',
      contrastText: '#ffffff',
    },
    background: {
      default: '#f8f9fa', // Off-white page background
      paper: '#ffffff',   // White card/section background
    },
    text: {
      primary: '#212121',   // Dark gray for main text
      secondary: '#5f6368', // Medium gray for secondary text
      disabled: '#9e9e9e',
    },
    success: {
      main: '#2e7d32', // Complementary green
    },
    info: {
      main: '#0288d1', // Blue for informational elements
    },
    divider: '#e0e0e0',
  },
  typography: {
    fontFamily: '"Segoe UI", "Roboto", "Helvetica Neue", Arial, sans-serif',
    h1: {
      fontWeight: 600,
      fontSize: '2.5rem',
      color: '#0288d1',
    },
    h2: {
      fontWeight: 600,
      fontSize: '2rem',
      color: '#0288d1',
      borderBottom: '2px solid #d32f2f',
      paddingBottom: '0.5rem',
    },
    h3: {
      fontWeight: 500,
      fontSize: '1.75rem',
      color: '#212121',
    },
    h4: {
      fontWeight: 500,
      fontSize: '1.5rem',
      color: '#0288d1',
    },
    body1: {
      fontSize: '1rem',
      lineHeight: 1.6,
    },
    button: {
      fontWeight: 600,
      textTransform: 'none', // Buttons use normal casing
    },
  },
  shape: {
    borderRadius: 8, // Rounded corners for cards and buttons
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          padding: '10px 24px',
        },
        containedPrimary: {
          backgroundColor: '#0288d1',
          '&:hover': {
            backgroundColor: '#0288d1',
          },
        },
        outlinedPrimary: {
          borderColor: '#0288d1',
          color: '#0288d1',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
          overflow: 'hidden',
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#ffffff',
          color: '#0288d1',
          boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
        },
      },
    },
    MuiLink: {
      styleOverrides: {
        root: {
          color: '#0288d1',
          fontWeight: 500,
        },
      },
    },
  },
});

export default sssSanjeevaniTheme;